/*
 * @name: T57700
 * @version: 1.0.0
 * @Date: 2022-06-15 10:17:08
 * @LastEditors: sueRimn
 * @LastEditTime: 2022-06-16 10:20:39
 */
import { post } from "@/utils/http";
class invoice {
    // /queryInvoice/queryPageInvoceApplyList
    // 待开发票
    queryPageInvoceApplyList(parme) {
            return post(
                '/queryInvoice/queryPageInvoceApplyList', parme
            )
        }
        // 开票历史 /queryInvoice/queryApplyedInvocieListByparms
    queryApplyedInvocieListByparms(parme) {
            return post(
                '/queryInvoice/queryApplyedInvocieListByparms', parme
            )
        }
        // 发送邮箱  /queryInvoice/sendInvoceEmail
    sendInvoceEmail(parme) {
            return post(
                '/queryInvoice/sendInvoceEmail', parme
            )
        }
        // 根据申请编码查询关联对账单号  /queryInvoice/queryStaatBillNoByApplyNO
    queryStaatBillNoByApplyNO(parme) {
            return post(
                '/queryInvoice/queryStaatBillNoByApplyNO', parme
            )
        }
        // 撤销发票接口  /queryInvoice/cancelInvoiceApply
    cancelInvoiceApply(parme) {
            return post(
                '/queryInvoice/cancelInvoiceApply', parme
            )
        }
        // 发票预览接口  /queryInvoice/privewInvoice
    privewInvoice(parme) {
        return post(
            '/queryInvoice/privewInvoice', parme
        )
    }

    // 发票红冲接口  /queryInvoice/invoiceToRed
    invoiceToRed(parme) {
            return post(
                '/queryInvoice/invoiceToRed', parme
            )
        }
        // 开票信息抬头 applyInvoice/queryCustomerTaxpayerInfo  
    queryCustomerTaxpayerInfo(parme) {
            return post(
                '/applyInvoice/queryCustomerTaxpayerInfo', parme
            )
        }
        // 发票确认对账单 applyInvoice/invoiceConfirmBillNo  
    invoiceConfirmBillNo(parme) {
            return post(
                '/queryInvoice/invoiceConfirmBillNo', parme
            )
        }
        // 开票接口 /applyInvoice/applyInvoiceList
    applyInvoiceList(parme) {
            return post(
                '/applyInvoice/applyInvoiceList', parme
            )
        }
        //  会计电话
    getMonthCustomerLeader() {
        return post(
            'clientManagement/getMonthCustomerLeader',
        );
    }
}
export default invoice